import React from "react";

export const InfoClinicaSVG = () => (
	<svg width={'30px'} fill="none" viewBox="0 0 20 20">
		<path
			d="M8.777 4.901V3.868h-1.55v1.033H6.194v1.55h1.033v1.033h1.55V6.45H9.81V4.9H8.777zm.516 1.036H8.26v1.034h-.517V5.937H6.71v-.516h1.033V4.388h.517V5.42h1.033v.516z"
			fill="#E78E4B"
			strokeWidth={3}
		/>
		<path
			d="M10.483 1.291l-.16-.318V0H5.68v.97l-.16.321H2.064V16h11.871V1.291h-3.452zm-4.803.835l.514-1.033V.517h3.612v.576l.517 1.033v.198H5.68v-.198zm7.745 13.357H2.581V1.808h2.68l-.097.198v.835h5.678v-.838l-.097-.198h2.68v13.678z"
			fill="#E78E4B"
			strokeWidth={3}
		/>
		<path
			d="M12.39 8.516H3.613v.517h8.775v-.517zM12.39 10.321H3.613v.517h8.775v-.517zM12.39 12.13H3.613v.516h8.775v-.516zM7.743 13.937H3.614v.516h4.13v-.516zM12.39 13.937h-.517v.516h.516v-.516zM11.356 13.937h-.517v.516h.517v-.516zM10.326 13.937H9.81v.516h.516v-.516z"
			fill="#E78E4B"
			strokeWidth={3}
		/>
	</svg>
);

export const ExamHistorySVG = () => (
	<svg width={'30px'} fill="none" viewBox="0 0 20 20">
		<path
			d="M13.84 2.785A7.327 7.327 0 008.625.625c-1.97 0-3.822.767-5.215 2.16A7.327 7.327 0 001.25 8c0 .975.186 1.918.553 2.807A2.316 2.316 0 000 13.062a2.315 2.315 0 002.313 2.313h4.75c.191 0 .378-.024.556-.068h.003c.33.045.668.068 1.003.068 1.592 0 3.107-.5 4.383-1.443a.313.313 0 00-.371-.503 6.695 6.695 0 01-3.996 1.32c.451-.421.734-1.022.734-1.687 0-.951-.578-1.77-1.401-2.124h1.734v2.526a.313.313 0 00.544.21l1.168-1.292a.545.545 0 01.403-.18 1.17 1.17 0 001.17-1.168V9.796c0-.157.126-.284.283-.284h.275a.91.91 0 00.908-.909v-.675a.91.91 0 00-.908-.908.284.284 0 01-.284-.284c0-.143-.03-.28-.083-.405h1.982c.136.534.209 1.093.209 1.669a6.696 6.696 0 01-1.315 4.003.313.313 0 00.503.371A7.316 7.316 0 0016 8c0-1.97-.767-3.822-2.16-5.215zm-2.168-.807c-.187.306-.289.66-.289 1.023a.3.3 0 01-.3.3c-.77 0-1.397.627-1.397 1.397 0 .38.131.73.35 1.008h-.971a1.56 1.56 0 00-1.558 1.558v.866c0 .35.116.672.311.932h-.193v-.124a.313.313 0 00-.313-.313H6.5v-.938a.312.312 0 00-.313-.312h-2.75a.312.312 0 00-.312.313v.937h-.813A.313.313 0 002 8.938v.365a6.795 6.795 0 01.145-3.193H4.41c.598 0 1.083-.486 1.083-1.083v-.032c0-.252.206-.458.459-.458.597 0 1.083-.486 1.083-1.083v-.168c0-.598-.486-1.084-1.083-1.084h-.781a6.71 6.71 0 013.453-.952c1.096 0 2.131.263 3.047.728zM10.5 9.688v.624H7.625v-.624H10.5zM5.875 8.624H3.75V8h2.125v.625zm-2.438.625H7v1.5H2.625v-1.5h.813zm.858-6.424l.022.001h1.636c.252 0 .458.206.458.459v.168a.459.459 0 01-.458.458c-.598 0-1.084.486-1.084 1.083v.032a.459.459 0 01-.458.458h-2.05a6.782 6.782 0 011.934-2.659zM8.75 13.062a1.69 1.69 0 01-1.688 1.688h-4.75a1.69 1.69 0 01-1.687-1.688c0-.93.757-1.687 1.688-1.687h4.75c.93 0 1.687.757 1.687 1.688zm3.892-6.326a.91.91 0 00.909.909c.156 0 .283.127.283.283v.675a.284.284 0 01-.283.284h-.275a.91.91 0 00-.909.909v1.238c0 .3-.244.544-.544.544-.33 0-.646.14-.867.385l-.623.69v-1.716h.167v.008a.312.312 0 10.625 0v-1.89a.312.312 0 10-.625 0v.008H9.065a.934.934 0 01-.933-.933v-.866c0-.515.419-.933.933-.933h3.172c.223 0 .405.182.405.405zm-.405-1.03h-.918a1.009 1.009 0 01-1.008-1.008c0-.425.347-.771.772-.771.51 0 .925-.416.925-.926 0-.254.073-.502.208-.714a6.786 6.786 0 012.757 3.419h-2.736z"
			fill="#E78E4B"
		/>
		<path
			d="M13.41 12.761l-.01.01a.313.313 0 00.445.439l.007-.007a.312.312 0 10-.442-.442zM6.25 13.063a.939.939 0 001.875 0 .939.939 0 00-1.875 0zm.938-.313a.313.313 0 11-.001.626.313.313 0 010-.626zM4.688 12.125a.939.939 0 000 1.875.939.939 0 000-1.875zm0 1.25a.313.313 0 110-.626.313.313 0 010 .626zM2.188 12.125a.939.939 0 000 1.875.939.939 0 000-1.875zm0 1.25a.313.313 0 110-.626.313.313 0 010 .626zM9.104 2.833h1.406a.312.312 0 100-.625H9.104a.313.313 0 000 .625zM7.82 2.833a.315.315 0 00.312-.313.315.315 0 00-.312-.312.315.315 0 00-.313.312.315.315 0 00.313.313z"
			fill="#E78E4B"
		/>
	</svg>
);

export const PhrasesSVG = () => (
	<svg width={'30px'} fill="none" viewBox="0 0 20 20">
		<g clipPath="url(#clip0)" fill="#E78E4B">
			<path d="M15.667 2.667H.333a.333.333 0 000 .666h15.334a.333.333 0 000-.666zM15.667 4.667H.333a.333.333 0 000 .666h15.334a.333.333 0 000-.666zM15.667 6.667H.333a.333.333 0 000 .666h15.334a.333.333 0 000-.666zM15.667 8.667H.333a.333.333 0 000 .666h15.334a.333.333 0 000-.666zM15.667 10.667H.333a.334.334 0 000 .666h15.334a.333.333 0 000-.666zM11 12.667H.333a.334.334 0 000 .666H11a.333.333 0 000-.666z" />
		</g>
		<defs>
			<clipPath id="clip0">
				<path d="M0 0h16v16H0V0z" fill="#fff" />
			</clipPath>
		</defs>
	</svg>
);

export const TemplatesSVG = () => (
	<svg width={'30px'} fill="none" viewBox="0 0 20 20">
		<path
			d="M14.697 0H13.563a.234.234 0 000 .469h1.056v1.566H1.381V.47h10.438a.234.234 0 000-.469H1.303a.391.391 0 00-.39.39V15.61c0 .215.174.39.39.39h13.394c.216 0 .39-.175.39-.39v-4.406a.234.234 0 00-.468 0v4.327H1.381V2.504h13.238v7.048a.234.234 0 10.469 0V.39a.391.391 0 00-.39-.39z"
			fill="#E78E4B"
		/>
		<path
			d="M5.344 10.86H2.378a.234.234 0 100 .47h2.966a.234.234 0 100-.47zM5.344 11.891H2.378a.234.234 0 000 .469h2.966a.234.234 0 000-.469zM5.344 12.923H2.378a.234.234 0 100 .468h2.966a.234.234 0 100-.468zM5.344 13.954H2.378a.234.234 0 000 .469h2.966a.234.234 0 000-.469zM9.483 10.86H6.517a.234.234 0 100 .47h2.966a.234.234 0 100-.47zM9.483 11.891H6.517a.234.234 0 000 .469h2.966a.234.234 0 000-.469zM9.483 12.923H6.517a.234.234 0 100 .468h2.966a.234.234 0 100-.468zM9.483 13.954H6.517a.234.234 0 000 .469h2.966a.234.234 0 000-.469zM13.622 10.86h-2.966a.234.234 0 100 .47h2.966a.234.234 0 100-.47zM13.622 11.891h-2.966a.234.234 0 000 .469h2.966a.234.234 0 000-.469zM13.622 12.923h-2.966a.234.234 0 100 .468h2.966a.234.234 0 100-.468zM13.622 13.954h-2.966a.234.234 0 000 .469h2.966a.235.235 0 000-.469zM13.622 3.224h-8.06a.234.234 0 100 .469h7.826v2.813H2.612V3.693h1.356a.234.234 0 100-.47h-1.59a.234.234 0 00-.234.235V6.74c0 .13.105.235.234.235h11.244c.13 0 .235-.105.235-.235V3.458a.234.234 0 00-.235-.234zM13.466 7.427h-2.653a.391.391 0 00-.391.391v2c0 .216.175.392.39.392h2.654c.215 0 .39-.176.39-.391V7.818a.391.391 0 00-.39-.39zm-.525.47l-.802.624-.801-.625h1.603zm-2.05.245l.867.676-.867.677V8.142zm.447 1.599l.801-.625.802.625h-1.603zm2.05-.246l-.868-.677.868-.676v1.353zM9.327 7.427H6.673a.391.391 0 00-.39.391v2c0 .216.175.392.39.392h2.654c.215 0 .39-.176.39-.391V7.818a.391.391 0 00-.39-.39zm-.526.47l-.8.624-.802-.625H8.8zm-2.05.245l.868.676-.867.677V8.142zM7.2 9.74L8 9.116l.801.625H7.2zm2.05-.246l-.868-.677.868-.676v1.353zM5.188 7.427H2.534a.391.391 0 00-.39.391v2c0 .216.175.392.39.392h2.654c.215 0 .39-.176.39-.391V7.818a.391.391 0 00-.39-.39zm-.526.47l-.801.624-.801-.625h1.602zm-2.05.245l.868.676-.868.677V8.142zM3.06 9.74l.8-.625.802.625H3.06zm2.05-.246l-.868-.677.867-.676v1.353zM10.78.629a.587.587 0 100 1.173.587.587 0 000-1.173zm0 .703a.117.117 0 110-.235.117.117 0 010 .235zM12.171.629a.587.587 0 10.001 1.173.587.587 0 00-.001-1.173zm0 .703a.117.117 0 110-.235.117.117 0 010 .235zM13.563.629a.587.587 0 10.001 1.173.587.587 0 00-.001-1.173zm0 .703a.117.117 0 110-.235.117.117 0 010 .235z"
			fill="#E78E4B"
		/>
	</svg>
);

export const SideBySideIcon = () => (
	<svg width={18} height={12} fill="none">
		<path
			d="M6.33 1H1.67C1.3 1 1 1.5 1 2.11V9.9c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V2.1C7 1.5 6.7 1 6.33 1zM16.33 1h-4.66c-.37 0-.67.5-.67 1.11V9.9c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V2.1C17 1.5 16.7 1 16.33 1z"
			stroke="#3F3F3F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const TopAndBotIcon = () => (
	<svg width={8} height={26} fill="none">
		<path
			d="M6.33 1H1.67C1.3 1 1 1.5 1 2.11V9.9c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V2.1C7 1.5 6.7 1 6.33 1zM6.33 15H1.67c-.37 0-.67.5-.67 1.11v7.78c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V16.1C7 15.5 6.7 15 6.33 15z"
			stroke="#3F3F3F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const TwoReportTwoExamIcon = () => (
	<>
		<svg width={8} height={26} fill="none">
			<path
				d="M6.33 1H1.67C1.3 1 1 1.5 1 2.11V9.9c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V2.1C7 1.5 6.7 1 6.33 1zM6.33 15H1.67c-.37 0-.67.5-.67 1.11v7.78c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V16.1C7 15.5 6.7 15 6.33 15z"
				stroke="#3F3F3F"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
		<svg width={8} height={26} fill="none">
			<path
				d="M6.33 1H1.67C1.3 1 1 1.5 1 2.11V9.9c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V2.1C7 1.5 6.7 1 6.33 1zM6.33 15H1.67c-.37 0-.67.5-.67 1.11v7.78c0 .61.3 1.11.67 1.11h4.66c.37 0 .67-.5.67-1.11V16.1C7 15.5 6.7 15 6.33 15z"
				stroke="#3F3F3F"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</>
);

export const DocumentIcon = () => (
	<i className="zmdi zmdi-attachment-alt" style={{ fontSize: '20px', fontWeight: 'bold', margin: '3px 0 0 3px' }}></i>
	/*
	<svg width={'20'} fill="none" viewBox="0 0 11 13">
		<path
			d="M10.5894 2.86344C10.5751 2.84912 10.5751 2.8348 10.5608 2.82048L8.12685 0.0859031C8.11254 0.0715859 8.0839 0.0572687 8.06958 0.0429515C8.05527 0.0429515 8.05527 0.0286344 8.04095 0.0286344C8.01232 0.0143172 7.96936 0 7.94073 0H1.97047C1.0828 0 0.366943 0.715859 0.366943 1.60352V11.3965C0.366943 12.2841 1.0828 13 1.97047 13H9.02884C9.9165 13 10.6324 12.2841 10.6324 11.3965V2.99229C10.6324 2.96366 10.618 2.9207 10.618 2.89207C10.6037 2.87775 10.6037 2.86344 10.5894 2.86344ZM8.19844 0.959251L9.77333 2.72026H8.19844V0.959251ZM10.1026 11.3822C10.1026 11.9692 9.63016 12.4416 9.04315 12.4416H1.97047C1.38346 12.4416 0.910996 11.9692 0.910996 11.3822V1.58921C0.910996 1.0022 1.38346 0.529736 1.97047 0.529736H7.6687V2.99229C7.6687 3.13546 7.78324 3.26432 7.94073 3.26432H10.1026V11.3822Z"
			fill="#3F3F3F"
		/>
		<path
			d="M4.64755 2.71973H2.28521C2.14204 2.71973 2.01318 2.83426 2.01318 2.99175C2.01318 3.14924 2.12772 3.26378 2.28521 3.26378H4.64755C4.79072 3.26378 4.91957 3.14924 4.91957 2.99175C4.91957 2.83426 4.79072 2.71973 4.64755 2.71973Z"
			fill="#3F3F3F"
		/>
		<path
			d="M4.64755 9.73535H2.28521C2.14204 9.73535 2.01318 9.84989 2.01318 10.0074C2.01318 10.1506 2.12772 10.2794 2.28521 10.2794H4.64755C4.79072 10.2794 4.91957 10.1649 4.91957 10.0074C4.90526 9.86421 4.79072 9.73535 4.64755 9.73535Z"
			fill="#3F3F3F"
		/>
		<path
			d="M8.59966 4.49512H2.3001C2.15693 4.49512 2.02808 4.60965 2.02808 4.76714C2.02808 4.91032 2.14261 5.03917 2.3001 5.03917H8.59966C8.74283 5.03917 8.87168 4.92463 8.87168 4.76714C8.85737 4.62397 8.74283 4.49512 8.59966 4.49512Z"
			fill="#3F3F3F"
		/>
		<path
			d="M8.59966 5.8125H2.3001C2.15693 5.8125 2.02808 5.92704 2.02808 6.08453C2.02808 6.2277 2.14261 6.35655 2.3001 6.35655H8.59966C8.74283 6.35655 8.87168 6.24202 8.87168 6.08453C8.85737 5.94135 8.74283 5.8125 8.59966 5.8125Z"
			fill="#3F3F3F"
		/>
		<path
			d="M8.59966 7.12988H2.3001C2.15693 7.12988 2.02808 7.24442 2.02808 7.40191C2.02808 7.54508 2.14261 7.67394 2.3001 7.67394H8.59966C8.74283 7.67394 8.87168 7.5594 8.87168 7.40191C8.85737 7.25874 8.74283 7.12988 8.59966 7.12988Z"
			fill="#3F3F3F"
		/>
		<path
			d="M8.59966 8.44727H2.3001C2.15693 8.44727 2.02808 8.5618 2.02808 8.71929C2.02808 8.86246 2.14261 8.99131 2.3001 8.99131H8.59966C8.74283 8.99131 8.87168 8.87678 8.87168 8.71929C8.85737 8.57612 8.74283 8.44727 8.59966 8.44727Z"
			fill="#3F3F3F"
		/>
	</svg>
	*/
);

export const EyeIcon = () => (
	<svg width={'20'} fill="none" viewBox="0 0 13 13">
		<path
			d="M0.541748 6.50032C0.541748 6.50032 2.70841 2.16699 6.50008 2.16699C10.2917 2.16699 12.4584 6.50032 12.4584 6.50032C12.4584 6.50032 10.2917 10.8337 6.50008 10.8337C2.70841 10.8337 0.541748 6.50032 0.541748 6.50032Z"
			stroke="#3F3F3F"
			strokeWidth="0.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.5 8.125C7.39746 8.125 8.125 7.39746 8.125 6.5C8.125 5.60254 7.39746 4.875 6.5 4.875C5.60254 4.875 4.875 5.60254 4.875 6.5C4.875 7.39746 5.60254 8.125 6.5 8.125Z"
			stroke="#3F3F3F"
			strokeWidth="0.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
